$(document).ocmsDynamicLoadFinished(function() {
    var $ajaxForms = $('main.authorText > .ocms-ajax-form');
    $ajaxForms.addClass('contentForm').wrap('<div class="mainSection">');
    $('td, table', $ajaxForms).removeAttr('style');
});